import React from 'react'
// libs
import { useRouter } from 'hooks/useRouter'
// hooks
import { useOfflineRiskCreate } from 'hooks/offline'
// views
import { FunctionContent, FunctionImage, FunctionTitle, FunctionWrapper } from './views'
// static
import ImagePlaceholder from '@mui/icons-material/Wallpaper'
// types
import { Widget } from 'store/reducers/dashboards'

interface Props {
  data: Widget
}

const Function: React.FC<Props> = ({ data }) => {
  const router = useRouter()
  const createRiskOffline = useOfflineRiskCreate()

  const { title, width, height, imageUrl, description, functionLink, openInWindow, imageFilename, riskTemplateId } =
    data.item.settings

  const hasLink = functionLink || riskTemplateId

  const onFunctionClick = () => {
    if (hasLink) {
      if (!navigator.onLine) {
        const tempId = createRiskOffline(riskTemplateId)

        router.push(`/forms/edit/${tempId}/template/${riskTemplateId}`)
        return
      }

      // TODO: remove /forms/create
      window.open(functionLink || `/forms/create/${riskTemplateId}`, openInWindow ? '_blank' : '_self')
    }
  }

  return (
    <FunctionWrapper hasLink={!!hasLink} width={width} height={height} onClick={onFunctionClick}>
      <FunctionTitle>{title || `< title >`}</FunctionTitle>
      <FunctionContent>
        {imageUrl ? <FunctionImage src={imageUrl} alt={imageFilename} /> : <ImagePlaceholder />}
        <div>{description || '< description >'}</div>
      </FunctionContent>
    </FunctionWrapper>
  )
}

export default Function
